import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconLogInProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconLogIn: React.FC<IconLogInProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Log in',
}) => {
    return (
        <IconBase color={color} size={size} className={className} title={title}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="m10 17 5-5-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15 12H3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </IconBase>
    );
};

export default IconLogIn;
